export const MIN_DEPOSIT_TO_PROPERTY_PRICE_RATIO = 0.1;
export const MAX_DEPOSIT_TO_PROPERTY_PRICE_RATIO = 0.9;
